import React, { useState, useEffect } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Grid,
  Button,
} from "@mui/material";

const MonthYearPicker = ({ onChange, partnerInvoiceUrl }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed
  const currentYear = currentDate.getFullYear();

  const [month, setMonth] = useState(currentMonth); // Default to current month
  const [year, setYear] = useState(currentYear); // Default to current year

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years

  useEffect(() => {
    // Notify parent about the default selection on initial render only
    if (onChange) {
      onChange({ month: currentMonth, year: currentYear });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleMonthChange = (event) => {
    setMonth(event.target.value);
    if (onChange) {
      onChange({ month: event.target.value, year });
    }
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
    if (onChange) {
      onChange({ month, year: event.target.value });
    }
  };
  const gridSize = partnerInvoiceUrl ? 4 : 6;
  return (
    <Grid container spacing={2}>
      {/* Month Dropdown */}
      <Grid item lg={gridSize} md={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="month-label">Month</InputLabel>
          <Select
            labelId="month-label"
            value={month}
            onChange={handleMonthChange}
          >
            {months.map((monthName, index) => (
              <MenuItem key={index} value={index + 1}>
                {monthName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {/* Year Dropdown */}
      <Grid item lg={gridSize} md={6} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Year</InputLabel>
          <Select labelId="year-label" value={year} onChange={handleYearChange}>
            {years.map((yearValue) => (
              <MenuItem key={yearValue} value={yearValue}>
                {yearValue}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {partnerInvoiceUrl && (
        <Grid lg={gridSize} md={6} item xs={12}>
          <Button
            variant="contained"
            onClick={() => window.open(partnerInvoiceUrl, "_blank")}
            sx={{ height: "54px" }}
          >
            View Invoice
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default MonthYearPicker;
